import React from 'react'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'

let ErrorModal = ({modal, toggle, className, title, text}) =>
    <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
            {text}
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={toggle}>OK</Button>
        </ModalFooter>
    </Modal>

export default ErrorModal



// WEBPACK FOOTER //
// ./src/components/ui/ErrorModal.js